import apiService from '../utils/apiService';

import {
  GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_ATTACHMENT,
  GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_ATTACHMENT_START,
  GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_ATTACHMENT_ERROR,
  CLEAR_ATTACHMENT_REQUEST_FOR_SIGNET_STATUS,
} from './types';
import { requestForSignetStatusAttachmentFindByRequest } from '../constants/apiEndpoints';

const clearAttachmentContent = () => {
  return {
    type: CLEAR_ATTACHMENT_REQUEST_FOR_SIGNET_STATUS,
  };
};

const getRequestForSignetStatusBySignetAttachmentStart = () => {
  return {
    type: GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_ATTACHMENT_START,
  };
};
const getRequestForSignetStatusBySignetAttachmentSuccessfully = (data) => {
  return {
    type: GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_ATTACHMENT,
    payload: data,
  };
};
const getRequestForSignetStatusBySignetAttachmentUnsuccessfully = (err) => {
  return {
    type: GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_ATTACHMENT_ERROR,
    payload: err,
  };
};

export const findRequestForSignetStatusAttachmentBySignetId = (
  requestForSignetStatusId
) => {
  return (dispatch) => {
    dispatch(getRequestForSignetStatusBySignetAttachmentStart());
    return apiService
      .get(
        requestForSignetStatusAttachmentFindByRequest(requestForSignetStatusId)
      )
      .then((response) => {
        dispatch(
          getRequestForSignetStatusBySignetAttachmentSuccessfully(response.data)
        );
      })
      .catch((err) => {
        dispatch(
          getRequestForSignetStatusBySignetAttachmentUnsuccessfully(
            err?.response?.data
          )
        );
      });
  };
};

export const clearContentRequestForSignetStatus = () => {
  return (dispatch) => {
    dispatch(clearAttachmentContent());
  };
};
